export default "__VITE_ASSET__8acb7785__"